import React from 'react'
import { formatNumToPercent, formatNumToFixed } from '../../../shared/utils'
import { getQuoteByIDList } from '../../../../modules/quote/web'
import useSWR from 'swr'

export function Indices() {
  const { data } = useSWR('myfavor/indices', () => getQuoteByIDList(['1.000001,0.399001,0.399006']), {
    refreshInterval: 30 * 1000
  })

  if (!data) {
    return <></>
  }

  const IndicesData = WrapComponent(Component)

  return (
    <div className="zhishu">
      {data.map((v) => (
        <a className="zs-wrap" key={v.market + '.' + v.code} href={`//wap.eastmoney.com/quote/stock/${v.market}.${v.code}.html`}>
          <p>{v.name}</p>
          <p>
            <IndicesData type="new_price" quote={v} />
          </p>
          <p>
            <IndicesData type="zde" quote={v} />
            <IndicesData type="zdf" quote={v} />
          </p>
        </a>
      ))}
    </div>
  )
}

function WrapComponent(Component: any) {
  const EnhancedComponent = (props: { type: 'zdf' | 'zde' | 'new_price'; quote: any }) => {
    if (props.type == 'zdf') {
      const zdf = formatNumToPercent(props.quote.zdf, props.quote.f152)
      return <Component {...props} data={zdf} />
    } else if (props.type == 'zde') {
      const zde = formatNumToFixed(props.quote.zde, props.quote.f1)
      return <Component {...props} data={zde} />
    } else {
      const new_price = formatNumToFixed(props.quote.new_price, props.quote.f1)
      return <Component {...props} data={new_price} />
    }
  }

  return EnhancedComponent
}

function Component(props: {quote:any,data:string | number}) {
  if (props.quote.zde == 0) {
    return <span>{props.data}</span>
  }

  if (props.quote.zde > 0) {
    return <span className="red">{props.data}</span>
  }

  if (props.quote.zde < 0) {
    return <span className="green">{props.data}</span>
  }

  return <></>
}
